import { defineMessages } from 'react-intl.macro';
import { TypOsobyEnum } from '../../openapi/types/TypOsobyEnum';
import { RegistryEnum } from '../../openapi/types/RegistryEnum';

export const subjectMessages = defineMessages({
  subjectDetailTitle: {
    id: 'subjectDetail.title',
    defaultMessage: '{id, select, empty {Subjekt} other {Subjekt č. {id}}}',
  },
  subjectListPageTitle: {
    id: 'subjectList.PageTitle',
    defaultMessage: 'Přehled subjektů',
  },
  subjectListStateWaiting: {
    id: 'subjectList.state.waiting',
    defaultMessage: 'Seznam subjektů se načítá.',
  },
  subjectListStateFail: {
    id: 'subjectList.state.fail',
    defaultMessage: 'Seznam subjektů se nepovedlo načíst.',
  },
  subjectListStateFilteredEmpty: {
    id: 'subjectList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  name: {
    id: 'subjectList.name',
    defaultMessage: 'Název',
  },
  person: {
    id: 'subjectList.person',
    defaultMessage: 'Typ osoby',
  },
  ico: {
    id: 'subjectList.ico',
    defaultMessage: 'IČO',
  },
  id: {
    id: 'subjectList.id',
    defaultMessage: 'ID subjektu',
  },
  address: {
    id: 'subjectList.address',
    defaultMessage: 'Adresa',
  },
  registry: {
    id: 'subjectList.btn.registry',
    defaultMessage: 'Registry',
  },
  search: {
    id: 'subjectList.search',
    defaultMessage: 'Název',
  },
  note: {
    id: 'subjectList.note',
    defaultMessage: 'Poznámka',
  },
});

export const subjectQueryMessages = defineMessages({
  loadQueryStateWaiting: {
    id: 'subject.load.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'subject.load.queryState.fail',
    defaultMessage: 'Zobrazení informací o subjektu se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateWaiting: {
    id: 'subject.submit.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  submitQueryStateSuccess: {
    id: 'subject.submit.success',
    defaultMessage: 'Změny uloženy.',
  },
  submitQueryStateFail: {
    id: 'subject.submit.fail',
    defaultMessage: 'Uložení změn se nepovedlo. Zkuste to prosím později.',
  },
});

export const subjectBtnMessages = defineMessages({
  filterSubmit: {
    id: 'subject.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  filter: {
    id: 'subject.btn.filter',
    defaultMessage: 'Filtr',
  },
  clear: {
    id: 'subject.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  save: {
    id: 'subject.btn.save',
    defaultMessage: 'Uložit',
  },
  exportCsv: {
    id: 'subject.btn.exportCsv',
    defaultMessage: 'Export do CSV',
  },
});

export const subjectPersonMessages = defineMessages<TypOsobyEnum>({
  [TypOsobyEnum.fyzickaOsoba]: {
    id: 'subject.person.fyzicka',
    defaultMessage: 'Fyzická osoba',
  },
  [TypOsobyEnum.pravnickaOsoba]: {
    id: 'subject.person.pravnicka',
    defaultMessage: 'Právnická osoba',
  },
});

export const registryMessages = defineMessages<RegistryEnum>({
  [RegistryEnum.SUBJEKT_EVIDENCE_DTI]: {
    id: 'subject.registry.subjektEvidenceDti',
    defaultMessage: 'Subjekt evidence DTI',
  },
  [RegistryEnum.EDITOR_ZPS]: {
    id: 'subject.registry.editorZPS',
    defaultMessage: 'Editor ZPS',
  },
  [RegistryEnum.IS_DTMK]: {
    id: 'subject.registry.isDtmk',
    defaultMessage: 'IS DTMK',
  },
  [RegistryEnum.AZI]: {
    id: 'subject.registry.azi',
    defaultMessage: 'AZI',
  },
  [RegistryEnum.OPRAVNENY_ZADATEL]: {
    id: 'subject.registry.opravnenyZadatel',
    defaultMessage: 'Oprávněný žadatel',
  },
  [RegistryEnum.BUDOUCI_STAVEBNIK]: {
    id: 'subject.registry.budouciStavebnik',
    defaultMessage: 'Budoucí stavebník',
  },
});
